const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/sublimd.ts';
import { KisApiAction } from '@cistec/common_web/defs/actionTypes';
import { actionLoadSublimdIFrameUrl, REQUEST_ACTION_TYPES_SUBLIMD } from 'App/actions/sublimd';
import { getData, makeReducer2, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { PatAppStoreState } from './setup/rootReducer';

export const sublimdReducer = makeReducer2([
    [
        REQUEST_ACTION_TYPES_SUBLIMD,
        (action: KisApiAction) => [action.meta.termNr],
        (action: KisApiAction) => action.payload.endpoint,
    ],
]);

const makeSelectSublimdUrl = (termNr: string) => (state: PatAppStoreState) => {
    return getData(state.sublimd, [termNr]);
};

// TODO: Due to not having a test environment for Sublimd We need to use AppointmentNr 11111 for testing.
export const useSublimdUrl = (termNr: string = '11111') => {
    return useRemoteData2('sublimd', {
        canRequest: !!termNr,
        request: dispatch => dispatch(actionLoadSublimdIFrameUrl(termNr)),
        select: makeSelectSublimdUrl(termNr),
    });
};
